import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-vision-mission',
  templateUrl: './home-vision-mission.component.html',
  styleUrls: ['./home-vision-mission.component.css']
})
export class HomeVisionMissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
